import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { updateLLMProject } from "../graphql/mutations";
import {
  UpdateLLMProjectInput,
  UpdateLLMProjectMutation,
} from "../API";

export async function updateLLMProjectRouting(
  values: UpdateLLMProjectInput
): Promise<GraphQLResult<UpdateLLMProjectMutation>> {

  console.log("updateLLMProjectRouting", values);
  return API.graphql(
    graphqlOperation(updateLLMProject, {
      input: {
        id: values.id,
        piiRedactionScope: values.piiRedactionScope ?? "identity|phone",
        piiScope: values.piiScope ?? "financial|credential",
        piiGroupId: values.piiGroupId !== undefined ? values.piiGroupId : "",
        piiMessage: values.piiMessage !== undefined ? values.piiMessage : "Prompt contains PII data.",
        promptBlacklist: values.promptBlacklist || "",
        blacklistGroupId: values.blacklistGroupId !== undefined ? values.blacklistGroupId : "",
        blacklistMessage: values.blacklistMessage !== undefined ? values.blacklistMessage : "Prompt contains blacklisted words.",
        safety: values.safety !== undefined ? values.safety : 0.85,
        safetyGroupId: values.safetyGroupId !== undefined ? values.safetyGroupId : "",
        safetyMessage: values.safetyMessage !== undefined ? values.safetyMessage : "Prompt contains unsafe language.",
        strongModelGroupId: values.strongModelGroupId ? values.strongModelGroupId : "",
        routeModel: values.routeModel || "none",
      },
    })
  ) as Promise<GraphQLResult<UpdateLLMProjectMutation>>;
}
